import _extends from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import * as React from 'react';
import { styled } from '@mui/material/styles';
import { useTranslate } from '../i18n';
import { adShape } from './AdManager';
import { adBodyImageStyles, adBodyInlineStyles } from './ad.styles';
import { useAdConfig } from './AdProvider';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var InlineShape = styled('span')(function (_ref) {
  var theme = _ref.theme;
  var styles = adBodyInlineStyles(theme);
  return _extends({}, styles.root, {
    '& img': styles.img,
    '& a, & a:hover': styles.a,
    '& .AdDisplay-imageWrapper': styles.imgWrapper,
    '& .AdDisplay-description': styles.description,
    '& .AdDisplay-poweredby': styles.poweredby
  });
});
var ImageShape = styled('span')(function (_ref2) {
  var theme = _ref2.theme;
  var styles = adBodyImageStyles(theme);
  return _extends({}, styles.root, {
    '& img': styles.img,
    '& a, & a:hover': styles.a,
    '& .AdDisplay-imageWrapper': styles.imgWrapper,
    '& .AdDisplay-description': styles.description,
    '& .AdDisplay-poweredby': styles.poweredby
  });
});
export default function AdDisplay(props) {
  var ad = props.ad,
    className = props.className,
    _props$shape = props.shape,
    shapeProp = _props$shape === void 0 ? 'auto' : _props$shape;
  var t = useTranslate();
  var _useAdConfig = useAdConfig(),
    GADisplayRatio = _useAdConfig.GADisplayRatio;
  React.useEffect(function () {
    // Avoid an exceed on the Google Analytics quotas.
    if (Math.random() > (GADisplayRatio != null ? GADisplayRatio : 0.1) || !ad.label) {
      return;
    }
    window.gtag('event', 'ad', {
      eventAction: 'display',
      eventLabel: ad.label
    });
  }, [GADisplayRatio, ad.label]);
  var shape = shapeProp === 'auto' ? adShape : shapeProp;
  var Root = shape === 'image' ? ImageShape : InlineShape;
  return /*#__PURE__*/_jsxs(Root, {
    className: className,
    children: [/*#__PURE__*/_jsxs("a", _extends({
      href: ad.link,
      target: "_blank",
      rel: "noopener sponsored"
    }, ad.label ? {
      'data-ga-event-category': 'ad',
      'data-ga-event-action': 'click',
      'data-ga-event-label': ad.label
    } : {}, {
      children: [/*#__PURE__*/_jsx("span", {
        className: "AdDisplay-imageWrapper",
        children: /*#__PURE__*/_jsx("img", {
          height: "100",
          width: "130",
          src: ad.img,
          alt: ad.name
        })
      }), /*#__PURE__*/_jsxs("span", {
        className: "AdDisplay-description",
        children: [/*#__PURE__*/_jsx("strong", {
          children: ad.descriptionHeader
        }), " - ", ad.description]
      })]
    })), /*#__PURE__*/_jsx("span", {
      className: "AdDisplay-poweredby",
      children: t('adPublisher').replace('{{publisher}}', ad.poweredby)
    })]
  });
}